/**
 * Test IDs for QA automation.
 */
export const testIds = {
  driverShiftAssignmentFormDriverPicker: "driver-shift-assignment-form-driver-picker",
  driverShiftAssignmentFormDriverSearch: "driver-shift-assignment-form-driver-search",
  driverShiftAssignmentFormDriverShiftPicker: "driver-shift-assignment-form-driver-shift-picker",
  driverShiftAssignmentForm1Day: "driver-shift-assignment-form-1-day",
  driverShiftAssignmentForm1Week: "driver-shift-assignment-form-1-week",
  driverShiftAssignmentFormPermanent: "driver-shift-assignment-form-permanent",
} as const;
